import { sdkRequest } from '@eventbrite/http';
import { formatUrl } from 'url-lib';

export const getfollowOrganizerChannelsGetURL = (userId: number) => {
    const followOrganizerEmailChannelId = '23';
    const followOrganizerNotificationChannelId = '10004';

    const followOrganizerSource = 'follow-organizer-gpdr-modal';
    const commSettingsRootURL = `/api/v3/message/users/${userId}/comm_settings/`;

    return `${commSettingsRootURL}?channel_ids=${followOrganizerEmailChannelId},${followOrganizerNotificationChannelId}&source=${followOrganizerSource}`;
};

type ErrorHandler = {
    error?: any;
    setIsUpdating: React.Dispatch<React.SetStateAction<boolean>>;
    setShouldShowLoginModal: React.Dispatch<React.SetStateAction<boolean>>;
};

export const errorHandler = ({
    error,
    setIsUpdating,
    setShouldShowLoginModal,
}: ErrorHandler) => {
    setIsUpdating(false);
    if (error?.parsedError?.error === 'NOT_AUTHORIZED') {
        setShouldShowLoginModal(true);
    }
};

type SetFollowStatus = {
    organizerId: string;
    setIsFollowing: React.Dispatch<React.SetStateAction<boolean>>;
    setFollowersCount: React.Dispatch<React.SetStateAction<number | null>>;
};

export const setFollowStatus = ({
    organizerId,
    setIsFollowing,
    setFollowersCount,
}: SetFollowStatus) =>
    sdkRequest(
        formatUrl(`/api/v3/organizers/${organizerId}/`, {
            'expand.organizer': 'follow_status',
        }),
    )
        .catch(() => {
            //this._handleError.bind(null, '', ERROR_ORG_INFO)
        })
        .then((response: any) => {
            if (response) {
                const { followed_by_you, num_followers } =
                    response.follow_status;

                setIsFollowing(followed_by_you);
                setFollowersCount(num_followers);
            }
        });

type FollowHandler = {
    organizerId: string;
    followUnfollowResponseHandler: (response: any) => void;
};

export const followOrganizer = ({
    organizerId,
    followUnfollowResponseHandler,
}: FollowHandler) =>
    sdkRequest(`/api/v3/destination/organizers/${organizerId}/follow/`, {
        method: 'POST',
    })
        .catch(errorHandler)
        .then(followUnfollowResponseHandler);

export const unfollowOrganizer = ({
    organizerId,
    followUnfollowResponseHandler,
}: FollowHandler) =>
    sdkRequest(`/api/v3/destination/organizers/${organizerId}/unfollow/`, {
        method: 'POST',
    })
        .catch(errorHandler)
        .then(followUnfollowResponseHandler);
